import ReactSelect from "@common/ReactSelect";
import { ADD_ONS_TYPE, APP_TYPE_AGENCY, INS_TYPE_COMPREHENSIVE, INS_TYPE_CTPL, REGEX_DECIMAL_VALIDATION, REGEX_DECIMAL_VALIDATION_8, WITH_RULE_ENGINE, WITHOUT_RULE_ENGINE,BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID,VEHICLE_USAGE_COMMERCIAL } from "@src/config/constant";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useState } from "react";
import * as HELPER from "@src/config/helper";
import InsuranceService from "@src/services/InsuranceService";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { saveInsurance } from "@store/slices/insurance";
import { getAddonList } from "@common/FunctionList";
import secureStorage from "@src/config/encrypt";
import AddonModal from "./AddonModal";
import { getPartnerInfo } from '@src/store/slices/insurance';
import PartnerInfoModal from "./PartnerInfoModal";


const Plans = forwardRef((props: any, ref) => {
    let { setLoading, setPage, sectionItem } = props

    const [refresh, setRefresh] = useState(false)
    const [value, setValue] = useState(1)
    const [addonDetail, setAddonDetail] = useState<Array<any>>([])
    const [inputField, setInputField] = useState<any>({})
    const [tempBaseRate, setTempBaseRate] = useState(inputField['base_issue_rate'])
    // eslint-disable-next-line
    const [vehicleDetails, setVehicleDetails] = useState(props?.sectionList?.find((item: any) => item.key === 'vehicle_details')?.blocks?.[0])
    const [selectedPartner, setSelectedPartner] = useState<any>({})
    const [editField, setEditField] = useState<any>(null)
    const [showTooltip, setShowTooltip] = useState('')
    const [showError, setShowError] = useState(false)

    const [showPartnerInfoModal, setShowPartnerInfoModal] = useState(false);

    const [partnerInfoDetail, setPartnerInfoDetail] = useState<any>(null);
    const [showPartnerInfoIcon, setShowPartnerInfoIcon] = useState(false);

    const [partnerInfoData, setPartnerInfoData] = useState<any>(null);

    const insurance: any = useSelector((state: any) => state.insurance)

    let { insurance_type, rule_engine } = insurance?.createInsurance

    let { user_data } = secureStorage.getItem("authAgentUserInfo") || {};
    // eslint-disable-next-line
    const [sectionItemData, setSectionItemData] = useState<any>(sectionItem)

    const [vehicleTypeInfo , setVehicleTypeInfo] = useState<any>();
    // store multiple partner
    const [partnerOptions, setPartnerOptions] = useState<any[]>([]);
    

    const dispatch: any = useDispatch()
    const navigate: any = useNavigate()
    const routeParams = useParams()
    const [searchParams] = useSearchParams()
    const isEditMode = props?.isEditMode || searchParams.get('edit') === 'true'
    const leadPathId = routeParams?.id || props?.resubmissionLeadId

    const getCreateInsuranceWithMmv = (overrides: any = {}) => {
        const createData = insurance?.createInsurance || {}
        const leadData = insurance?.resubmissionLeadData || {}
        return {
            ...createData,
            lead_id: createData.lead_id ?? leadData.lead_id ?? leadData.leadId,
            make: createData.make ?? leadData.make,
            make_name: createData.make_name ?? leadData.make_name,
            model: createData.model ?? leadData.model,
            model_name: createData.model_name ?? leadData.model_name,
            version: createData.version ?? leadData.version,
            version_name: createData.version_name ?? leadData.version_name,
            parent_model_id: createData.parent_model_id ?? leadData.parent_model_id,
            parent_model_name: createData.parent_model_name ?? leadData.parent_model_name,
            ...overrides,
        }
    }

    const navigateToVehicleDetails = () => {
        setLoading(false)
        setPage(2)
        const path = leadPathId ? `/create-insurance-policy/${leadPathId}` : '/create-insurance-policy'
        const params = new URLSearchParams({ step: 'vehicle_details' })
        if (isEditMode) params.set('edit', 'true')
        navigate(`${path}?${params.toString()}`)
    }

    // Keep vehicle form data in sync when Edit Application jumps directly to Premium Plan
    useEffect(() => {
        const nextVehicleDetails = props?.sectionList?.find((item: any) => item.key === 'vehicle_details')?.blocks?.[0]
        if (nextVehicleDetails) {
            setVehicleDetails(nextVehicleDetails)
        }
    }, [props?.sectionList])

    const resolveFieldValue = (field: any) => {
        if (field?.value === undefined || field?.value === null || field?.value === '') return undefined
        if (typeof field.value === 'object') return field.value?.value
        return field.value
    }

    const getClassificationId = (vehicleInfo: any) => {
        const classificationField = vehicleInfo?.find((e: any) => e.name === 'classification_id')
        const fromField = resolveFieldValue(classificationField)
        if (fromField !== undefined && fromField !== null && fromField !== '') return fromField

        return insurance?.resubmissionLeadData?.classification_id
            ?? insurance?.createInsurance?.classification_id
            ?? undefined
    }

    const getCommercialType = (vehicleInfo: any) => {
        const commercialField = vehicleInfo?.find((e: any) => e.name === 'commercial_type')
        const fromField = resolveFieldValue(commercialField)
        if (fromField !== undefined && fromField !== null && fromField !== '') return fromField

        return insurance?.resubmissionLeadData?.commercial_type
            ?? insurance?.resubmissionLeadData?.commercial_type_id
            ?? insurance?.createInsurance?.commercial_type
            ?? undefined
    }

    const normalizePartnerId = (raw: any) => {
        if (raw === undefined || raw === null || raw === '') return null
        return Array.isArray(raw) ? raw[0] : raw
    }

    /** Partner originally saved on the lead (edit / resubmission) */
    const getOriginalPartnerId = () => normalizePartnerId(insurance?.resubmissionLeadData?.partner_id)

    /** Partner to restore on Plans page — lead first, then in-progress create state */
    const getPreviousPartnerId = () =>
        normalizePartnerId(insurance?.resubmissionLeadData?.partner_id)
        ?? normalizePartnerId(insurance?.createInsurance?.partner_id)

    const shouldPrefillFromLead = (currentPartnerId: any) => {
        const originalId = getOriginalPartnerId()
        const currentId = normalizePartnerId(currentPartnerId)
        return originalId != null && currentId != null && +originalId === +currentId
    }

    const toPartnerOption = (partner: any) => partner ? ({
        id: partner.id,
        value: partner.id,
        label: partner.name || partner.label,
        slug: partner.slug,
        name: partner.name || partner.label,
        logo: partner.logo
    }) : null

    const fetchPartners = async () => {
        let params: any = {}

        const vehicleInfo = vehicleDetails?.fields;
        let vehicleClassification = vehicleInfo?.find((e: any) => e.name === 'vehicle_classification')
        let insuranceType = resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'insurance_type'))
            ?? insurance_type
            ?? insurance?.resubmissionLeadData?.insurance_type
            ?? insurance?.resubmissionLeadData?.insurance_type_id
        let tenure = resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'tenure'))

        let vehicleType = resolveFieldValue(vehicleClassification)
            ?? insurance?.createInsurance?.vehicle_type
            ?? insurance?.resubmissionLeadData?.vehicle_type
            ?? insurance?.resubmissionLeadData?.vehicle_type_id
        setVehicleTypeInfo(vehicleType);
        let vehicleUsage = vehicleClassification?.value?.vehicle_usage
            ?? insurance?.createInsurance?.vehicle_usage
            ?? insurance?.resubmissionLeadData?.vehicle_usage
        let classificationId = getClassificationId(vehicleInfo)

        params['vehicle_type'] = vehicleType
        params['vehicle_usage'] = vehicleUsage
        params['insurance_type'] = insuranceType
        params['classification_id'] = classificationId
        if (vehicleUsage === VEHICLE_USAGE_COMMERCIAL) {
            params['commercial_type'] = getCommercialType(vehicleInfo)
        }
        params['tenure'] = tenure

        if (!(vehicleType || vehicleUsage)) {
            return navigateToVehicleDetails()
        }

        // getPartner requires classification_id — wait until it is available
        if (classificationId === undefined || classificationId === null || classificationId === '') {
            toast.error("Vehicle classification is required")
            return navigateToVehicleDetails()
        }

        setLoading(true);
        let result = await InsuranceService.getPartnerList(params)
        setLoading(false);
        if (result?.data?.data) {
            let partnerDetails = result?.data?.data
            const options = partnerDetails?.map((p: any) => ({
                value: p.id,
                label: p.name,
                slug: p.slug,
                name: p.name,
                logo: p.logo
            }));
            setPartnerOptions(options);

            const previousPartnerId = getPreviousPartnerId()
            const matchedPartner = previousPartnerId != null
                ? partnerDetails?.find((p: any) => +p.id === +previousPartnerId)
                : null
            const restoredPartner = toPartnerOption(matchedPartner)

            // Default / single-partner fallback
            const firstPartner = partnerDetails?.length > 0 ? toPartnerOption(partnerDetails[0]) : null
            const partnerToSelect = restoredPartner || (partnerDetails?.length === 1 ? firstPartner : null)

            if (partnerToSelect) {
                setSelectedPartner(partnerToSelect)
                await dispatch(saveInsurance(getCreateInsuranceWithMmv({
                    partner_id: partnerToSelect.value,
                    partner_slug: partnerToSelect.slug
                })))
            } else {
                setSelectedPartner(null)
            }

        } else {
            toast.error(result?.data?.message)
            navigateToVehicleDetails()
        }
    }

    const fetchAddons = async (reqParam?: any) => {
        setLoading(true)

        const vehicleInfo = vehicleDetails?.fields
        let vehicleClassification = vehicleInfo?.find((e: any) => e.name === 'vehicle_classification')
        let vehicleType = resolveFieldValue(vehicleClassification)
            ?? insurance?.createInsurance?.vehicle_type
            ?? insurance?.resubmissionLeadData?.vehicle_type
            ?? insurance?.resubmissionLeadData?.vehicle_type_id
        let insuranceType = insurance_type
            ?? insurance?.resubmissionLeadData?.insurance_type
            ?? insurance?.resubmissionLeadData?.insurance_type_id
            ?? resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'insurance_type'))
        const prefillFromLead = shouldPrefillFromLead(reqParam?.partner_id || selectedPartner?.value)
        if (vehicleType && insuranceType) {
            let params = {
                rule_engine,
                vehicle_type: vehicleType,
                apptype: APP_TYPE_AGENCY,
                insurance_type: insuranceType,
                source: 'agency_app'
            }
            let result = await InsuranceService.getAddonList(params)
            if (result?.data?.data) {
                let originalList = result.data.data
                
                let carfinanceTypeItem = resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'car_under_finance'))

                let is_required = (carfinanceTypeItem && +carfinanceTypeItem === 1) ? true : false
                if (originalList.length > 0) {
                    originalList = originalList.map((ob: any) => {
                        const prevSelectedItem: any = prefillFromLead
                            ? (insurance?.resubmissionLeadData?.addon_detail?.find((ele: any) => +ele.id === +ob.id) || {})
                            : {}
                        if (ob.type === 'pa') {
                            if (ob.is_selected || prevSelectedItem?.['id']) getVersionSeat(ob)

                            if (prevSelectedItem['extra_seat_capacity']) {
                                ob['extra_seat_value'] = prevSelectedItem['extra_seat_capacity']
                            }
                        }
                        return {
                            ...ob, ...prevSelectedItem, coverage_amt: prevSelectedItem?.['coverage_amount'] || ob['coverage_amt'],
                            is_required: (ob.id === 6) ? is_required : ob.is_required,
                            is_selected: prevSelectedItem?.['id'] ? true : ob.is_selected//(addon_detail?.length ? false : ob.is_selected)
                        }
                    })
                }
                const addons = getAddonList({ original_list: originalList }, null, rule_engine)
                //api call to fetch plans
                fetchPlans({}, { addonDetail: addons, partner_id: reqParam?.partner_id })
                
                setAddonDetail(originalList)
            }
        } else {
            setLoading(false)
        }
    }

    const fetchPlans = async (reqParam?: any, otherParams?: any): Promise<any> => {
        let partner_id = otherParams?.partner_id || selectedPartner?.value;
        if (!partner_id) {
            toast.error("Please select a partner before fetching plans");
            return { checkValue: false, message: "Partner not selected" };
        }

        setLoading(true)
        let flag = true
        let editableFields = ['discount', 'add_on_rate','referrer_mark_up']
        let addonDetails = otherParams?.addonDetail || getAddonList({ original_list: addonDetail }, null, rule_engine)

        const vehicleInfo = vehicleDetails?.fields
        const vehicleClassification = vehicleInfo?.find((e: any) => e.name === 'vehicle_classification')
        const vehicleType = resolveFieldValue(vehicleClassification)
            ?? insurance?.createInsurance?.vehicle_type
            ?? insurance?.resubmissionLeadData?.vehicle_type
            ?? insurance?.resubmissionLeadData?.vehicle_type_id
        const vehicleUsage = vehicleClassification?.value?.vehicle_usage
            ?? insurance?.createInsurance?.vehicle_usage
            ?? insurance?.resubmissionLeadData?.vehicle_usage
        const carFmv = resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'car_fmv'))
            ?? insurance?.resubmissionLeadData?.car_fmv
            ?? insurance?.resubmissionLeadData?.total_fmv
            ?? insurance?.createInsurance?.car_fmv
        const make = resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'make_year'))
            ?? insurance?.resubmissionLeadData?.make_year
            ?? insurance?.createInsurance?.make_year
        const classification_id = getClassificationId(vehicleInfo)
        const planInsuranceType = insurance_type
            ?? insurance?.resubmissionLeadData?.insurance_type
            ?? insurance?.resubmissionLeadData?.insurance_type_id
            ?? resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'insurance_type'))
        


        if (rule_engine === WITHOUT_RULE_ENGINE) editableFields.push('net_premium')

        let params: any = {
            agency_id: user_data?.agency_id,
            vehicle_usage: vehicleUsage,
            insurance_type: planInsuranceType,
            rule_engine: rule_engine,
            total_fmv: +carFmv,
            apptype: APP_TYPE_AGENCY,
            vehicle_type: vehicleType,
            partner_id: Array.isArray(partner_id) ? partner_id[0] : partner_id,
            lead_type: 5,
            make_year: make,
            addon_detail: addonDetails ?? [],
            classification_id:classification_id
        }
        if(vehicleUsage===VEHICLE_USAGE_COMMERCIAL){
            params={...params,commercial_type:getCommercialType(vehicleInfo)}
           
        }

        // Edit / resubmission: prefill premium only when the original partner is still selected
        if (shouldPrefillFromLead(partner_id)) {
            const leadData = insurance?.resubmissionLeadData || {}
            const leadQuotes = leadData?.quotes || {}
            const createData = insurance?.createInsurance || {}
            const changableFields = ['net_premium', 'base_issue_rate', 'discount', 'referrer_mark_up']
            for (let key of changableFields) {
                let savedValue = leadData?.[key] ?? leadQuotes?.[key] ?? createData?.[key]
                // Lead SQL aliases base_issue_rate as add_on_rate
                if ((savedValue === undefined || savedValue === null || savedValue === '') && key === 'base_issue_rate') {
                    savedValue = leadData?.add_on_rate ?? createData?.add_on_rate
                }
                if (savedValue !== undefined && savedValue !== null && savedValue !== '') {
                    let updatedKey = key === 'base_issue_rate' ? 'add_on_rate' : key
                    params[updatedKey] = savedValue
                }
            }
        }

        if (params.insurance_type === INS_TYPE_CTPL) {
            params['tenure'] = resolveFieldValue(vehicleInfo?.find((e: any) => e.name === 'tenure'))
                ?? insurance?.resubmissionLeadData?.tenure
                ?? insurance?.createInsurance?.tenure
        }

        editableFields.forEach((field: any) => {
            if (reqParam?.[field] || insurance?.createInsurance?.[field === 'add_on_rate' ? 'base_issue_rate' : field]) {
                if (field === 'net_premium' && !reqParam?.[field]) { }
                else {
                    params[field] = reqParam?.[field] || insurance?.createInsurance?.[field === 'add_on_rate' ? 'base_issue_rate' : field]
                }
            }
        })

        let result = await InsuranceService.getAddonDetails(params)
        let message: any = null
        if (result?.data?.data) {
            //save total premium in state for installment validation
            // let { total_premium, base_issue_rate, discount, net_premium } = result.data.data
            setInputField({ ...result.data.data, validation: true })
            setValue((prev: any) => prev + 1)
            setTempBaseRate(result?.data?.data?.base_issue_rate)

        } else {
            message = result.data.message
            flag = false
            if (showError || rule_engine === WITH_RULE_ENGINE) {
                toast.error(message)
            }
            setInputField((prev: any) => ({ ...prev, validation: false }))
            setShowError(true)
            //if first time api call & no valid response
            //then redirect back to addons page
            // if (value === 0) {
            //     props.setPage(1)
            //     props.setActiveKey('1')
            // }
        }
        setLoading(false)
        return new Promise((resolve) => resolve({ checkValue: flag, message, base_issue_rate: result?.data?.data?.base_issue_rate }))
    }

    const isComprensive = insurance_type === INS_TYPE_COMPREHENSIVE ? true : false

    const onChangeCheckbox = (addonItem: any, event: any) => {        
        if (addonItem.is_required) {
            addonItem.is_selected = true
        } else {
            addonItem['is_selected'] = !addonItem.is_selected
        }

        if([BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleTypeInfo)){
            if (addonItem.is_selected) getVersionSeat(addonItem)
        }
        if(!addonItem.is_required && addonItem.type === "tra"){
            updateAddonsAndCallApi(addonDetail, '');
        }
        setRefresh(!refresh)
    }

    const onValueSelect = (addonItem: any, event: any) => {
        addonItem['coverage_amt'] = event.value

        if (addonItem.type === 'bi' || addonItem.type === 'pd') {
            const oppositeType = addonItem.type === 'bi' ? 'pd' : 'bi';

            const oppositeAddon = addonDetail.find(
                (item: any) => item.type === oppositeType
            );

            if (oppositeAddon) {
                oppositeAddon.coverage_amt = event.value;
            }
        }
        
        setValue(value + 1)
        updateAddonsAndCallApi(addonDetail, 'coverage')
    }

    const getSeatingCapacityList = (item: any) => {
        const vehicleInfo = vehicleDetails?.fields
        let vehicleClassification = vehicleInfo?.find((e: any) => e.name === 'vehicle_classification')

        let vehicleType = vehicleClassification?.value?.value
        if([BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleType)){
            return item.seat_capacity_list;
        }else{
            let versionSeat = item.max_seat_capacity
            versionSeat = +versionSeat
            var tempList = []
            for (var index = 1; index <= versionSeat; index++) {
                const optionParam = {
                    "value": index,
                    "label": index
                }
                tempList.push(optionParam)
            }
            return tempList
        }
    }

    const saveExtraSeatingValue = (item: any, event: any) => {
        item.extra_seat_value = event.value
        setValue(value + 1)
        updateAddonsAndCallApi(addonDetail, 'extra_seating')

    }

    const saveSeatingValue = (item: any, event: any) => {
        item.seat_capacity = event.value
        setValue(value + 1)
        updateAddonsAndCallApi(addonDetail, 'seating_capacity')
    }

    const getExtraSeatingCapacityList = (item: any) => {
        let versionSeat = item.max_seat_capacity

        if (versionSeat) {
            versionSeat = +versionSeat
            var tempList = []
            for (var index = 1; index <= versionSeat; index++) {
                const optionParam = {
                    "value": index,
                    "label": index
                }
                tempList.push(optionParam)
            }
            return tempList
        }
        return []
    }

    const getPremiumTitle = (item: any, key: string) => {
        if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type && isComprensive && isRuleEngine()) {
            return ''
        }
        else if (ADD_ONS_TYPE.ACTS_OF_NATURE === item.type || ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL === item.type || ADD_ONS_TYPE.TOWING_ROWDSIDE === item.type) {
            return ''
        } else if (isComprensive && isRuleEngine()) {
            if (key === "title") {
                return "Premium Amount :"
            } else {
                return HELPER.addCurrencyFormatting(getPremiumAmount(item))
            }
        }
        return ''
    }


    const isRuleEngine = () => {
        if (rule_engine === 1) return true
        else return false
    }

    const getPremiumAmount = (item: any) => {
        if (isComprensive && isRuleEngine()) {
            if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type) {
                return item.premium_amount || ''
            }
            let filterItem = item?.coverage_list?.filter((option: any) => option.value === item.coverage_amt)?.[0]
            if (filterItem)
                return filterItem?.premium_amount || ''
            else
                return 0
        }
        else {
            return item.premium_amount ? item.premium_amount : ''
        }
    }


    const isShowPremiumInputBox = (addonItem: any) => {
        if (((!isComprensive && !isRuleEngine()) || (!isRuleEngine() && isComprensive)) && ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL !== addonItem.type && ADD_ONS_TYPE.TOWING_ROWDSIDE !== addonItem.type) {
            return true
        }
        else {
            if (addonItem.is_editable && !isRuleEngine()) { //ONLY IN CASE OF TRA WITHOUT RULE ENGINE
                return true
            } else {
                //FOR OONA & MERCENTILE IF COVERAGE AMT IS MATCHED FROM API THEN SHOW INPUT BOX
                // if (addonItem.type === ADD_ONS_TYPE.PERSONAL_ACCIDENT && ["oona", "milestone"].includes(insurance?.createInsuranceAgency?.partner_slug)) {
                if (addonItem.type === ADD_ONS_TYPE.PERSONAL_ACCIDENT && ["oona", "milestone"].includes(insurance?.createInsurance?.partner_slug)) {
                    if (addonItem.coverage_amt === addonItem.oona_coverage_amount_limit || addonItem.coverage_amt === addonItem.milestone_coverage_amount_limit) {
                        addonItem.premium_amount = ''
                        return false
                    } else {
                        return (addonItem.coverage_amt) ? true : false //MANUAL PREMIUM INPUT ALLOW 
                    }

                } else {
                    return false
                }
            }
        }
    }

    const onChangePremiumAmount = (addonItem: any, text: any) => {
        // validate two decimal digit value
        // Validate input field of allow two decimal value 
        if (REGEX_DECIMAL_VALIDATION.test(text) || text === '') {
            if (!isComprensive && isRuleEngine()) {
                addonItem.coverage_amt = text ? text : ''
            }
            else {
                addonItem.premium_amount = text ? text : ''
            }
            updateAddonsAndCallApi(addonDetail, 'premium')
            setValue(value + 1)
        }
    }

    const getVersionSeat = (item: any) => {
        const vehicleInfo = vehicleDetails?.fields
      
        let seatCapacityField = vehicleInfo?.find((e: any) => e.name === 'seat_capacity');
        let seatCapacity;
        if (seatCapacityField?.type === 'dd') {
            seatCapacity = seatCapacityField?.value?.value;
        } else if (seatCapacityField?.type === 'tb') {
            seatCapacity = seatCapacityField?.value;
        }
      
        if (seatCapacity) {
            item['seat_capacity'] = +seatCapacity
        }
    }

    const handleAmountChange = async (key: string, value: any) => {
        if (key === 'temp_base_rate') {
            if ((REGEX_DECIMAL_VALIDATION_8.test(value)) || REGEX_DECIMAL_VALIDATION.test(value) || value === '') {
                setTempBaseRate(value)
            }
            return
        }

        if ((key === "add_on_rate" && REGEX_DECIMAL_VALIDATION_8.test(value)) || REGEX_DECIMAL_VALIDATION.test(value) || value === '') {
            let { basic_rate_min, basic_rate_max, base_issue_rate, discount,
                referrer_mark_up } = inputField

            const fields: any = {
                add_on_rate: +base_issue_rate,
                discount,
                referrer_mark_up,
               
            }

            //for addonrate
            if (key === 'add_on_rate') {
                if ((value && value[value?.length - 1] === '.') || !value || +value === 0 || (value && value[value?.length - 1] === '0')) {
                    setInputField((prev: any) => ({ ...prev, base_issue_rate: value }))
                    return
                }

                if (+value !== 0 && (+value < basic_rate_min || +value > basic_rate_max)) {
                    toast.error(`Base issue rate should be between ${basic_rate_min} - ${basic_rate_max}`)
                    return
                }
                fetchPlans({ ...fields, add_on_rate: +value })

            }

            if (key === 'net_premium') {
                fetchPlans({ ...fields, net_premium: +value })
            }
            if (key === 'discount') {
                if (value) value = value.toString().replace(/^0+/, '')
                let response: any = null
                let editFlag = true
                if (+value >= 10) {
                    response = await fetchPlans({ ...inputField,add_on_rate:inputField?.base_issue_rate, [key]: +value })
                    if (!response?.checkValue) {
                        editFlag = false
                    }
                }
                if (editFlag) {
                    setInputField((prev: any) => ({ ...prev, [key]: value }))
                }
            }

            if (key === 'referrer_mark_up') {
                if (value) value = value.toString().replace(/^0+/, '');
                fetchPlans({ ...inputField,add_on_rate:inputField?.base_issue_rate, [key]: +value  })
            }
        }
    }

    const updateAddonsAndCallApi = async (addonList: any, type = '') => {
        //type to display base issue rate change popup
        const addons = getAddonList({ original_list: addonList }, null, rule_engine)

        const { checkValue, base_issue_rate } = await fetchPlans(null, { addonDetail: addons, partner_id: selectedPartner?.id })

        //display base rate popup
        if (['coverage', 'extra_seating', 'seating_capacity'].includes(type) && checkValue && base_issue_rate !== tempBaseRate) {
            toast.success("Base issue rate has been reset to default")
        }
    }

    const callApis = async () => {
        await fetchPartners()
    }

    useEffect(() => {
        callApis()

        return (() => {
            setShowError(false)
        })
        // eslint-disable-next-line
    }, [])

    useImperativeHandle(ref, () => ({
        getData: () => ({ quotes: inputField, addonList: addonDetail, partnerDetails: selectedPartner }),
      validate: () => {
        if (!selectedPartner?.value) { 
            toast.error("Please select a partner before continuing");
            return false;
        }
        return true;
    }
    }))

    useEffect(() => {
        const fetchPartnerInfo = async () => {
            try {
                let result: any = await getPartnerInfo();
                setPartnerInfoData(result?.insurancePartnerInfo);
                let show = result?.insurancePartnerInfo?.find((e: any) => e.slug === selectedPartner?.slug);
                setShowPartnerInfoIcon(!!show); // Sets true if `show` exists, otherwise false
            } catch (error) {
                setShowPartnerInfoIcon(false);
            }
        };
        fetchPartnerInfo();
    }, [selectedPartner]);

    const showPartnerInfoPopup = async () => {
        let show = partnerInfoData?.find((e: any) => e.slug === selectedPartner?.slug)
        if (show) {
            setShowPartnerInfoModal(true);
            setPartnerInfoDetail(show);
        }
        return;
    }
  
    const handleChange = (key: string, event: any) => {
        if (key === "partner_id") {
            setSelectedPartner(event || null);
            setInputField({})
            setTempBaseRate(undefined)
            setShowError(false)
            // store partner_id; clear prior premium so a new partner recalculates cleanly
            dispatch(saveInsurance(getCreateInsuranceWithMmv({
                partner_id: event?.value || null,
                partner_slug: event?.slug || null,
                base_issue_rate: undefined,
                net_premium: undefined,
                discount: undefined,
                referrer_mark_up: undefined,
                add_on_rate: undefined,
            })));
        }
         if (event?.value) {
            fetchAddons({ partner_id: event.value });
        }
    };

    // addon api will call only when it has partner id
    useEffect(() => {
        if (selectedPartner?.value) {
            fetchAddons({ partner_id: selectedPartner.value });
        }
    // eslint-disable-next-line
    }, [selectedPartner]);

    return (
        <>
            <PartnerInfoModal show={showPartnerInfoModal} handleClose={() => setShowPartnerInfoModal(false)} content={partnerInfoDetail} />
            <div className="row">
                <div className="col-md-12">
                    <h2>{sectionItemData?.blocks?.[0]?.title}</h2>
                </div>
                </div>
                        
            <div className="col-md-6 m-lg-r premium-plan-filed-outer p-l-r-0">
                <div className="row">
                    
                    <div className="col-md-12 m-lg-t select-partner">
                            <div className="material">
                                
                                <ReactSelect
                                    options={partnerOptions || []}
                                    value={selectedPartner || null}
                                    handleChange={(e: any) => handleChange("partner_id", e)}
                                    placeholder="Select Partner"
                                    fieldKey=""
                                    fieldSetClassName="col-md-12 "
                                    innerClass={"select-partenrt-dropdown"}
                                />
                            </div>
                       
                    </div>
                    <div className='col-md-12 m-lg-t partner-logo'> <div className="row"> 
                    {(partnerOptions.length === 1 || selectedPartner?.value) && (
                    <div className="col-md-12" key={selectedPartner?.slug}>
                        <div id={`partner-${selectedPartner?.id}`} className={`premium-plan-logo active m-t-0`}>
                            <div className="agency-partner-logo">
                                <img src={selectedPartner?.logo} className="" alt={`partner-logo`} />
                                <div className="agency-partner-name">
                                    {selectedPartner?.name}
                                </div>
                            </div>
                            {/* <i className="ic-arrow_forward_ios"></i> */}
                            {
                                showPartnerInfoIcon &&
                                <i className="ic-info-icon1" onClick={() => { showPartnerInfoPopup() }}></i>
                            }
                        </div>
                    </div >
                    )}
                    </div></div>
                </div>
                {
                    addonDetail.length
                        ?
                        addonDetail.map((addonItem: any, idx: number) => {
                            return (
                                <div key={addonItem.id + (" " + idx + 1)} className="addon-listing">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="">

                                                <fieldset className="form-filed common-application-checkbox">
                                                    <div className="custom-control custom-checkbox ">
                                                        <input checked={addonItem.is_selected} id="addon_id" type="checkbox" className="custom-control-input " name="addon_id" onChange={(event) => {
                                                            onChangeCheckbox(addonItem, event)
                                                        }} />
                                                        <label className="custom-control-label checkbox-label-txt"><span className="addon-list-heading">{addonItem.name}</span></label>
                                                    </div>
                                                    <span data-tooltip-id="my-tooltip-0" title="" className="tooltio-ic">
                                                        <i className="ic-info-icon1" onClick={() => {
                                                            setShowTooltip(addonItem.type)
                                                        }}></i>
                                                    </span>
                                                </fieldset>
                                            </div>
                                        </div>
                                        {
                                            addonItem?.is_selected &&
                                            <>
                                                {
                                                    addonItem.coverage_list?.length > 0 &&
                                                    <>
                                                        <ReactSelect
                                                            options={addonItem.coverage_list || []}
                                                            value={addonItem.coverage_amt ? { label: addonItem.coverage_amt, value: addonItem.coverage_amt } : null}
                                                            handleChange={(e: any, fieldKey: string) => onValueSelect(addonItem, e)}
                                                            placeholder="Choose Coverage Amount"
                                                            fieldKey=""
                                                            fieldSetClassName="col-md-12 "
                                                            isDisabled={(!isComprensive || props?.resubmissionLeadId || addonItem.is_disabled) ? true : false}
                                                            innerClass={"m-xl-l"}
                                                        />
                                                    </>
                                                  
                                                }

                                                {
                                                    addonItem.type === 'pa' && <>
                                                        <ReactSelect
                                                            options={getSeatingCapacityList(addonItem)}
                                                            placeholder="Seating Capacity"
                                                            isDisabled={![BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleTypeInfo) ? props?.resubmissionLeadId : true}
                                                            // isDisabled={(props.versionSeat || (addonDetail?.find((e: any) => e.id === 3 && e.seat_capacity)))}
                                                            value={props.versionSeat ? { label: props.versionSeat, value: props.versionSeat } : addonItem.seat_capacity ? { label: addonItem.seat_capacity, value: addonItem.seat_capacity } : null}
                                                            handleChange={(e: any) => saveSeatingValue(addonItem, e)} fieldSetClassName="col-md-12"
                                                            innerClass={"m-xl-l"}
                                                        />
                                                        
                                                        <ReactSelect
                                                            options={getExtraSeatingCapacityList(addonItem)}
                                                            placeholder="Extra Seating Capacity"
                                                            value={addonItem?.extra_seat_value ? { label: addonItem.extra_seat_value, value: addonItem.extra_seat_value } : null}
                                                            handleChange={(e: any) => saveExtraSeatingValue(addonItem, e)} fieldSetClassName="col-md-12"
                                                            innerClass={"m-xl-l"}
                                                            isDisabled={![BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleTypeInfo) ? props?.resubmissionLeadId : true}
                                                        />
                                                        
                                                    </>
                                                }

                                                {
                                                    getPremiumTitle(addonItem, 'title')?.length > 0 &&
                                                    <>
                                                        <fieldset className="form-filed col-md-12">
                                                            <div className="premium-amt-bg m-xl-l">
                                                                <span>{getPremiumTitle(addonItem, 'title')}</span>
                                                                <span>{getPremiumTitle(addonItem, 'value')}</span>
                                                            </div>
                                                        </fieldset>
                                                    </>

                                                }
                                                {
                                                    isShowPremiumInputBox(addonItem)
                                                        ?
                                                        !props?.resubmissionLeadId
                                                            ?
                                                            <fieldset className="form-filed col-md-12 p-lg-b">
                                                                <div className="material m-xl-l">
                                                                    <input id="" type="text" placeholder="" name="name" className="form-input" value={getPremiumAmount(addonItem)} onChange={(event) => {
                                                                        onChangePremiumAmount(addonItem, event.target.value);
                                                                    }} />
                                                                    <label data-label={"Premium Amount"} className="form-label"></label>
                                                                </div>
                                                            </fieldset>
                                                            :
                                                            <fieldset className="form-filed col-md-12 p-lg-b">
                                                                <div className="material m-xl-l">
                                                                    <input id="" type="text" placeholder="" name="name" className="form-input" value={getPremiumAmount(addonItem)} />
                                                                    <label data-label={"Premium Amount"} className="form-label"></label>
                                                                </div>
                                                            </fieldset>
                                                        : undefined
                                                }
                                                {
                                                    showTooltip === addonItem.type &&
                                                    <AddonModal show={true} type={showTooltip} handleClose={() => setShowTooltip('')} title={addonItem.name} description={addonItem.description} />
                                                }
                                            </>
                                        }
                                    </div>
                                </div>

                            )
                        })
                        : undefined
                }
            </div >
            {(partnerOptions.length === 1 || selectedPartner?.value) && (
            <div className="row col-md-6 m-lg-t">
                <div className="premium-detail-bg">
                    <div className="col-md-12">
                        <h2>{"Premium Details"}</h2>
                    </div>
                    <div className="row p-lg-t align-center">

                        {
                            insurance_type !== INS_TYPE_CTPL
                                ?
                                <>
                                    <fieldset className={'col-md-8 p-sm-t col-xs-8'}>
                                        <div className="material">
                                            {
                                                <input
                                                    maxLength={10}
                                                    disabled={false}
                                                    type='text'
                                                    placeholder=" "
                                                    name={'Base Issue Rate'}
                                                    className="form-input"
                                                    value={tempBaseRate || ''}
                                                    onChange={(event) => {
                                                        const text = event.target.value
                                                        handleAmountChange('temp_base_rate', text)
                                                    }}
                                                />
                                            }
                                            <label data-label={'Base Issue Rate *'} className="form-label"></label>
                                        </div>
                                    </fieldset>
                                    {
                                        props?.resubmissionLeadId
                                            ?
                                            <div className="col-md-4 col-xs-4 m-sm-t p-lg-b">
                                                <button className="btn-primary btn-width-auto" onClick={() => { }} disabled>Apply</button>
                                            </div>
                                            : <div className="col-md-4 col-xs-4 m-sm-t p-lg-b">
                                                <button className="btn-primary btn-width-auto" onClick={() => {
                                                    handleAmountChange('add_on_rate', tempBaseRate)
                                                }}>Apply</button>
                                            </div>
                                    }
                                </>
                                : null
                        }
                    </div>
                    <div className='financer-quote-data w-100'>
                        <div className="agency-quote-list">
                            <ul>
                                {
                                    (insurance_type === INS_TYPE_COMPREHENSIVE && ![BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleTypeInfo)) ?
                                        <li>
                                            <span>Act of Nature</span>
                                            <label>{(addonDetail?.filter((el: any) => el.id === 6).length > 0) ? `Included` : `Not Included`}</label>
                                        </li> : null
                                }
                                <li>
                                    <span>FMV of Car</span>
                                    <label title={`${HELPER.addCurrencyFormatting(inputField.total_fmv)}`}>  {HELPER.addCurrencyFormatting(inputField.total_fmv)}</label>
                                </li>

                                <li>
                                    <span>Own Theft Damage</span>
                                    <label title={`${HELPER.addCurrencyFormatting(inputField.own_theft_damage)}`}>  {HELPER.addCurrencyFormatting(inputField.own_theft_damage)}</label>
                                </li>
                                {
                                    ![BIKE_INS_VEHICLE_TYPE_ID,COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID].includes(vehicleTypeInfo) && insurance_type !== INS_TYPE_CTPL &&
                                    <li>
                                        <span>BI Premium</span>
                                        <label title={`${HELPER.addCurrencyFormatting(inputField.bi_amt)}`}>  {HELPER.addCurrencyFormatting(inputField.bi_amt)}</label>
                                    </li>
                                }
                                {
                                    inputField.hasOwnProperty('pa_amt') && inputField.pa_amt > 0 ?
                                        <>
                                            <li>
                                                <span>PA Premium</span>
                                                <label title={`${HELPER.addCurrencyFormatting(inputField.pa_amt)}`}>  {HELPER.addCurrencyFormatting(inputField.pa_amt)}</label>
                                            </li>
                                        </>
                                        : null
                                }
                                {
                                    inputField.hasOwnProperty('pd_amt') ?
                                        <>
                                            <li>
                                                <span>PD Premium</span>
                                                <label title={`${HELPER.addCurrencyFormatting(inputField.pd_amt)}`}>  {HELPER.addCurrencyFormatting(inputField.pd_amt)}</label>
                                            </li>
                                        </>
                                        : null
                                }
                                {
                                    (inputField.hasOwnProperty('tra_amt')) ?
                                        <li>
                                            <span>TRA Premium</span>
                                            <label title={`${HELPER.addCurrencyFormatting(inputField.tra_amt)}`}>  {HELPER.addCurrencyFormatting(inputField.tra_amt)}</label>
                                        </li> : null
                                }
                                {
                                    (inputField.hasOwnProperty('rscc_amount')) ?
                                        <li>
                                            <span>RSCC Premium</span>
                                            <label title={`${HELPER.addCurrencyFormatting(inputField.rscc_amount)}`}>  {HELPER.addCurrencyFormatting(inputField.rscc_amount)}</label>
                                        </li> : null
                                }
                                {
                                    insurance_type === INS_TYPE_COMPREHENSIVE ?
                                        <li>
                                            <span>{inputField.hasOwnProperty('rscc_amount') ? 'BI + PD + PA + RSCC' : 'BI + PD + PA'}</span>
                                            <label title={`${HELPER.addCurrencyFormatting(inputField.bi_pd_pa)}`}>  {HELPER.addCurrencyFormatting(inputField.bi_pd_pa)}</label>
                                        </li> : null
                                }

                                <li>
                                    <span>Net Premium</span>
                                    {
                                        editField === 'net_premium' ?
                                            <label>
                                                <fieldset>
                                                    <div className="material">
                                                        <input type="number" name={'net_premium'} className="form-input input-edit" value={+inputField.net_premium || ''} onChange={(e) => {
                                                            handleAmountChange('net_premium', e.target.value)
                                                        }} onBlur={() => setEditField(null)} />
                                                    </div>
                                                </fieldset>
                                            </label>
                                            :
                                            <label>  {HELPER.addCurrencyFormatting(+inputField.net_premium)}
                                                {insurance_type === INS_TYPE_COMPREHENSIVE && rule_engine === WITHOUT_RULE_ENGINE &&
                                                    <i className='ic-edit pointer edit-icon' onClick={() => setEditField('net_premium')}></i>
                                                }
                                            </label>
                                    }
                                </li>

                                <li>
                                    <span>VAT</span>
                                    <label title={`${HELPER.addCurrencyFormatting(inputField.vat)}`}>  {HELPER.addCurrencyFormatting(inputField.vat)}</label>
                                </li>
                                <li>
                                    <span>Stamp Duty Govt</span>
                                    <label title={`${HELPER.addCurrencyFormatting(inputField.stamp_duty)}`}>  {HELPER.addCurrencyFormatting(inputField.stamp_duty)}</label>
                                </li>
                                <li>
                                    <span>Local Govt Taxes</span>
                                    <label title={`${HELPER.addCurrencyFormatting(inputField.local_govt_taxes)}`}>  {HELPER.addCurrencyFormatting(inputField.local_govt_taxes)}</label>
                                </li>
                                {
                                    inputField.tariff > 0 &&
                                    <li>
                                        <span>Tariff</span>
                                        <label title={`${HELPER.addCurrencyFormatting(inputField.tariff)}`}>  {HELPER.addCurrencyFormatting(inputField.tariff)}</label>
                                    </li>
                                }


                                {
                                    inputField.participation_fees &&
                                    <li>
                                        <span>Participation Fees</span>
                                        <label title={`${HELPER.addCurrencyFormatting(inputField.participation_fees)}`}>  {HELPER.addCurrencyFormatting(inputField.participation_fees)}</label>
                                    </li>
                                }
                                
                                {
                                    (inputField.hasOwnProperty('discount')) ?   
                                    <li>
                                        <span>Discount to Customer</span>
                                        {
                                            editField === 'discount' ?
                                            <label>
                                                <fieldset className="discountplan">
                                                    <div className="material">
                                                        <input type="number" name={editField} className="form-input input-edit" value={(inputField.discount || inputField.discount === 0) ? inputField.discount : 0}
                                                            onChange={(e) => {
                                                                handleAmountChange('discount', e.target.value)
                                                            }}
                                                            onBlur={() => {
                                                                setEditField(null)
                                                                if (inputField.discount !== 0 && inputField.discount < 10) {
                                                                    toast.error("Please enter a valid discount amount")
                                                                    setInputField((prev: any) => ({ ...prev,discount:0}))
                                                                }
                                                            }} />
                                                    </div>
                                                </fieldset>
                                            </label>
                                            :
                                            <label>  {HELPER.addCurrencyFormatting((inputField.discount || inputField.discount === 0) ? inputField.discount : 0)}
                                                {
                                                    <i className='ic-edit pointer edit-icon' onClick={() => {
                                                        setEditField('discount')
                                                    }}></i>
                                                }

                                            </label>
                                        }
                                    </li>:null 
                                }
                                {
                                    (inputField.hasOwnProperty('referrer_mark_up')) ?
                                    <li>
                                        <span>Referrer Mark Up</span>
                                        {
                                            editField === 'referrer_mark_up' ?
                                            <label>
                                                <fieldset className="discountplan">
                                                    <div className="material">
                                                        <input type="number" name={editField} className="form-input input-edit" value={inputField.referrer_mark_up} 
                                                        onChange={(e) => handleAmountChange('referrer_mark_up',e.target.value)}
                                                            onBlur={() => {
                                                                setEditField(null)} 
                                                            } />
                                                    </div>
                                                </fieldset>
                                            </label>
                                                :
                                            <label>  {HELPER.addCurrencyFormatting((inputField.referrer_mark_up || inputField.referrer_mark_up === 0) ? inputField.referrer_mark_up : 0)}
                                                {
                                                    <i className='ic-edit pointer edit-icon' onClick={() =>  setEditField('referrer_mark_up')}></i>
                                                }

                                            </label>
                                        }
                                    </li> : null
                                }
                                {
                                    inputField.total_premium
                                        ?
                                        <li>
                                            <span>Total Premium</span>
                                            <label title={`${HELPER.addCurrencyFormatting(inputField.total_premium)}`}>
                                                {HELPER.addCurrencyFormatting((inputField.total_premium))}
                                            </label>
                                        </li>
                                        : null
                                }
                                

                            </ul>
                            <div className="gross-premium-bg m-sm-t">
                                <span>Gross Premium</span>
                                <label title={`${HELPER.addCurrencyFormatting(inputField.gross_premium)}`}>  {HELPER.addCurrencyFormatting(inputField.gross_premium)}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            
        </>
    )
})

export default Plans
